module.exports = __webpack_public_path__ + "img/project-management1.c700f100.jpg";